import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { finalize, tap } from "rxjs/operators";
import { HttpRequestHistoryItem } from "../models/http-request-history-item.model";
import { HttpRequestHistoryService } from "../services/http-request-history.service";

@Injectable()
export class HttpRequestHistoryInterceptor implements HttpInterceptor {

    private readonly history = inject(HttpRequestHistoryService);

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        let startedAt = Date.now();
        let recorded = false;
        let recordedItem: HttpRequestHistoryItem;
        let record = (statusCode: number, headers: HttpHeaders = null): HttpRequestHistoryItem => {
            if (recorded) {
                return recordedItem;
            }
            recorded = true;

            let parsedUrl = this.history.parseUrl(request.urlWithParams);
            recordedItem = {
                date: new Date(),
                method: request.method,
                route: parsedUrl.route,
                queryParameterNames: parsedUrl.queryParameterNames,
                statusCode,
                durationMs: Date.now() - startedAt,
                backendErrorId: headers?.get("portal-backend-error-id"),
                traceId: headers?.get("portal-trace-id") ?? headers?.get("traceparent") ?? headers?.get("x-request-id")
            };
            this.history.add(recordedItem);
            return recordedItem;
        };

        return next.handle(request).pipe(
            tap({
                next: event => {
                    if (event instanceof HttpResponse) {
                        record(event.status, event.headers);
                    }
                },
                error: error => {
                    let response = error instanceof HttpErrorResponse ? error : null;
                    let item = record(response?.status, response?.headers);
                    if (response != null) {
                        this.history.associateError(response, item);
                    }
                }
            }),
            finalize(() => record(null))
        );
    }
}
